// src/frontend/components/common/Message.tsx
import { message as AntMessage } from "antd";
import React from "react";

export type MessageType = "success" | "error" | "warning" | "info" | "loading";

interface MessageOptions {
    content: React.ReactNode;
    type?: MessageType;
    duration?: number;
    onClose?: () => void;
}

export const Message = {
    success: (content: React.ReactNode | MessageOptions, duration?: number) => {
        if (typeof content === "string" || React.isValidElement(content)) {
            return AntMessage.success(content, duration);
        }
        return AntMessage.success((content as MessageOptions).content, (content as MessageOptions).duration);
    },

    error: (content: React.ReactNode | MessageOptions, duration?: number) => {
        if (typeof content === "string" || React.isValidElement(content)) {
            return AntMessage.error(content, duration);
        }
        return AntMessage.error((content as MessageOptions).content, (content as MessageOptions).duration);
    },

    warning: (content: React.ReactNode | MessageOptions, duration?: number) => {
        if (typeof content === "string" || React.isValidElement(content)) {
            return AntMessage.warning(content, duration);
        }
        return AntMessage.warning((content as MessageOptions).content, (content as MessageOptions).duration);
    },

    info: (content: React.ReactNode | MessageOptions, duration?: number) => {
        if (typeof content === "string" || React.isValidElement(content)) {
            return AntMessage.info(content, duration);
        }
        return AntMessage.info((content as MessageOptions).content, (content as MessageOptions).duration);
    },

    show: (options: MessageOptions) => {
        const { content, type = "info", duration = 3 } = options;
        const config = { content, duration };

        switch (type) {
            case "success":
                return AntMessage.success(config);
            case "error":
                return AntMessage.error(config);
            case "warning":
                return AntMessage.warning(config);
            case "loading":
                return AntMessage.loading(config);
            default:
                return AntMessage.info(config);
        }
    },
};